import Image from 'components/Image';

const BaseFullLayout = ({ children }) => {
  return (
    <div
      className="flex min-h-screen flex-col justify-center bg-cover bg-center py-12 px-4 sm:px-6 lg:px-8 relative"
      style={{
        backgroundImage: "url('/images/backgrounds/bg-login-titan.webp')",
      }}>
      <div className="absolute top-4 left-4">
        <Image
          className="mx-auto h-10 w-auto"
          src="/images/logos/titan_logo_1_white.svg"
          alt="Titan Payment Logo"
          fill
          priority
        />
      </div>
      <div className="sm:mx-auto sm:w-full sm:max-w-[480px]">
        <div className="bg-gray-400 rounded-xl bg-clip-padding backdrop-filter backdrop-blur-xs bg-opacity-10 border border-transparent px-6 py-8 sm:px-8 shadow-xl">
          <Image
            className="mx-auto h-24 w-auto mb-4"
            src="/images/logos/titan_helmet_white.png"
            alt="Titan Payment Logo"
            fill
            priority
          />
          {children}
        </div>
      </div>
    </div>
  );
};

export default BaseFullLayout;
